module.exports = "https://bin.bnbstatic.com/_next/static/images/api-home-7fa68410248fe15c4c8c53a2b8a03516.png";